module.exports = __webpack_public_path__ + "static/media/carbono_banner.c821a42c.png";